export default "__VITE_ASSET__ce249335__"